<template>
    <h1>Sol·licitud enviada</h1>
    <div class="alert alert-info" role="alert">
    <p><br />La vostra sol·licitud ha estat enviada al personal del Servei de Normalització Bibliogràfica de la Biblioteca de Catalunya.
    <br /><br />Aquests es posaran en contacte amb la institució per establir les línies de col·laboració i formalitzar un conveni de mutu acord.</p>
    <p><br />Envieu qualsevol dubte o pregunta relacionades amb el procés de sol·licitud a <a href="mailto:smb@bnc.cat">snb@bnc.cat</a></p>
    </div>
</template>